import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://2c560f4883b91f9cf58fa3d5269f01c3@o1388406.ingest.us.sentry.io/4509200200237056",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

emitter.on("ui-ready", () => {
  import("./main.app");  
})

emitter.on("initialized", () => {
    emitter.emit("load");
});

import("./app");


